import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideChevronDown,
  lucideChevronUp,
  lucideX,
  lucideExternalLink,
  lucideFileDown,
} from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmSpinner } from '@spartan-ng/helm/spinner';
import {
  PdfExportDownloadJob,
  PdfExportDownloadService,
} from '@src/app/core/services/pdf-export-download.service';

@Component({
  selector: 'app-pdf-export-downloads-panel',
  standalone: true,
  imports: [CommonModule, TranslocoModule, NgIcon, HlmButtonImports, HlmSpinner],
  templateUrl: './pdf-export-downloads-panel.component.html',
  providers: [
    provideIcons({
      lucideChevronDown,
      lucideChevronUp,
      lucideX,
      lucideExternalLink,
      lucideFileDown,
    }),
  ],
})
export class PdfExportDownloadsPanelComponent {
  readonly svc = inject(PdfExportDownloadService);
  readonly ui$ = this.svc.ui$;

  trackJob(_index: number, job: PdfExportDownloadJob): string {
    return job.id;
  }

  openJob(job: PdfExportDownloadJob): void {
    this.svc.openJobInBrowser(job);
  }
}
